
export const translateFunc = (t, labelTranslate, origin) => {
    const translate = t(labelTranslate);
    return translate === labelTranslate ? origin : translate;
};